import { get, getPage, post, put, del } from '@/utils/request'

export interface AITestTask {
  id: number
  title: string
  source_type: string
  status: 'pending' | 'running' | 'completed' | 'failed'
  model_name: string
  total_cases: number
  requirement_summary: string
  error_message: string
  create_time: string
  update_time: string
}

export interface AITestCaseItem {
  id: number
  task_id: number
  case_id: string
  module: string
  sub_module: string
  title: string
  priority: string
  design_method: string
  precondition: string
  steps: string
  expected: string
  tags: string
  source_requirement: string
  version: string
  create_time: string
  update_time: string
}

export interface ParseResult {
  filename: string
  source_type: string
  content: string
  char_count: number
}

export interface GenerateResult {
  task_id: number
  requirement_summary: string
  total_cases: number
}

/** 上传并解析需求文档 */
export function parseDocument(file: File) {
  const formData = new FormData()
  formData.append('file', file)
  return post<ParseResult>('/ai-test-cases/parse', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

/** 生成测试用例 */
export function generateTestCases(data: {
  title: string
  document: string
  source_type: string
  model_name?: string
}) {
  return post<GenerateResult>('/ai-test-cases/generate', data, { timeout: 300000 })
}

/** 获取任务列表 */
export function listTasks(params: { page?: number; page_size?: number; keyword?: string; status?: string }) {
  return getPage<AITestTask>('/ai-test-cases/tasks', params)
}

/** 获取任务详情 */
export function getTaskDetail(taskId: number) {
  return get<AITestTask & { source_document: string }>(`/ai-test-cases/tasks/${taskId}`)
}

/** 获取任务的用例列表 */
export function listCases(taskId: number) {
  return get<AITestCaseItem[]>(`/ai-test-cases/${taskId}/cases`)
}

/** 更新用例 */
export function updateCase(caseId: number, data: Record<string, any>) {
  return put<AITestCaseItem>(`/ai-test-cases/cases/${caseId}`, data)
}

/** 删除任务 */
export function deleteTask(taskId: number) {
  return del(`/ai-test-cases/tasks/${taskId}`)
}

/** 导出 Excel */
export const exportExcelUrl = (taskId: number) => `/api/v1/ai-test-cases/${taskId}/export`

/** 导出 Xmind */
export const exportXmindUrl = (taskId: number) => `/api/v1/ai-test-cases/${taskId}/export-xmind`

/** 触发文件下载（带 token） */
export function downloadFile(url: string, filename: string) {
  const tokenStore = localStorage.getItem('auroratest-auth')
  // 注意：token 存储在 localStorage 中存在 XSS 泄露风险
  // 生产环境建议改用 httpOnly cookie + SameSite 策略
  let token = ''
  if (tokenStore) {
    try {
      const parsed = JSON.parse(tokenStore)
      token = parsed.state?.token || ''
    } catch (e) { console.error('[aiTestCases] 操作失败:', e) }
  }
  const xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  xhr.setRequestHeader('Authorization', `Bearer ${token}`)
  xhr.responseType = 'blob'
  xhr.onload = () => {
    if (xhr.status === 200) {
      const blob = new Blob([xhr.response])
      const downloadUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = filename
      a.click()
      URL.revokeObjectURL(downloadUrl)
    }
  }
  xhr.send()
}
